import { Position } from '../../interfaces'
import { Batch } from '../../interfaces/Batch'
import { UserWms } from '../../interfaces/Picking/Picking'

export enum eInventoryCheckSteps {
  SearchInventoryCheck,
  ShowInventoryCheckPositions,
  WatingScreen,
  ScanSkus,
  Error,
  SuccessInventoryCheck,
  AllCyclicals,
  AuditDetail
}

export interface InventoryCheck {
  inventoryCheckId: number
  stateId: number
  createdDate: string
  promiseDate: string
  typeInventoryCheckId: number
  tag: string
  totalPosition: number
}

export interface SharedStateType {
  workOrderId?: number
  positionCode?: string | undefined
  positionId?: number
  workOrder?: InventoryCheck
  position?: Position
  skuList?: SkuInfo[]
  error: string
  user?: UserWms
  inventoryCheckDetails?: InventoryCheckDetail
  inventoryCheckDetailId?: number
  batchList?: Batch[]
  selectedSku?: SkuBatchInfoDto
  zoneName?: string
  warehouseName?: string
  stepTitle?: string
  hideBackButton?: boolean
  closePositionFailed?: boolean // true solo si falló la API de cierre al presionar Finalizar
}

export interface SkuInfo {
  sku: string
  ean13: string
  skuId?: number
  checkedQty: number
  validated: boolean
  productOriginId?: number
  brandName?: string
  batchId?: number | null
  batch?: Batch
  hasExpirationDate?: boolean
  hasBatch?: boolean
}

export interface InventoryCheckPosition {
  positionId: number
  positionName: string
  zoneName: string
  warehouseName: string
}

export interface InventoryCheckDetail {
  inventoryCheckDetailId: number
  positionName: string
  startDate: string
  endDate: string
  cycle: number
  userAlias: string
}

export interface SkuBatchInfoDto {
  skuId: number
  sku: string
  ean13: string
  productOriginId: number  
  batches: Batch[]
  hasExpirationDate?: boolean
  hasBatch?: boolean
}
